import { formatCents } from '@/libs/utils/format-money';

/**
 * The collab fee's minimum, written in the currency the surface already prices
 * in. The floor is minor units of the collab's own currency, never converted,
 * so without a currency the bare figure is still true: "minimum 10".
 */
export function formatCollabFeeFloor(
  floorMinorUnits: number,
  currencyCode: string | null | undefined,
  locale: string
): string {
  if (currencyCode) return formatCents(floorMinorUnits, currencyCode, locale);
  try {
    return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(
      floorMinorUnits / 100
    );
  } catch {
    return String(floorMinorUnits / 100);
  }
}
